import _classCallCheck from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import React, { Component } from 'react';
import _ from 'lodash';
import TablePagination from '@material-ui/core/TablePagination';
import DataTable from './DataTable';

var PaginatedStaticDataTable =
/*#__PURE__*/
function (_Component) {
  _inherits(PaginatedStaticDataTable, _Component);

  function PaginatedStaticDataTable() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, PaginatedStaticDataTable);

    var _temp;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _possibleConstructorReturn(_this, (_temp = _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(PaginatedStaticDataTable)).call.apply(_getPrototypeOf2, [this].concat(args))), _this.state = {
      page: 0,
      limit: 10,
      pagination: false,
      docs: [],
      text: undefined,
      order: undefined,
      column: undefined
    }, _this.componentWillReceiveProps = function (nextProps) {
      _this.setState({
        pagination: (nextProps.docs || []).length > _this.state.limit,
        docs: nextProps.docs || [],
        sort: nextProps.sort,
        text: nextProps.text
      });

      if (nextProps.selectionByProps && nextProps.multiSelectId === undefined) {
        var indexOfSelected = -1;

        _this.state.docs.forEach(function (doc, index) {
          if (doc.id === nextProps.selectionByProps.id) {
            indexOfSelected = index;
          }
        });

        if (indexOfSelected > -1) {
          _this.setState({
            page: Math.floor(indexOfSelected / _this.state.limit)
          });
        } else {
          _this.setState({
            page: 0
          });
        }
      } else {
        _this.setState({
          page: 0
        });
      }
    }, _this.handleChangePage = function (event, page) {
      _this.setState({
        page: page
      });
    }, _this.handleChangeRowsPerPage = function (event) {
      var limit = _this.state.limit;

      if (limit !== event.target.value) {
        _this.setState({
          limit: event.target.value,
          page: 0
        });
      }
    }, _this.handleColumnSort = function (order, column) {
      _this.setState({
        order: order,
        column: column
      }, _this.filterDocs);
    }, _this.filterDocs = function () {
      var _this$props = _this.props,
          docs = _this$props.docs,
          mapping = _this$props.mapping;
      var _this$state = _this.state,
          order = _this$state.order,
          column = _this$state.column,
          text = _this$state.text;
      var colDesc = mapping.filter(function (m) {
        return m.column === column;
      })[0];

      if (text !== undefined) {
        docs = docs.filter(function (doc) {
          return _this.hasTextValue(doc, text);
        });
      }

      if (order === undefined || column === undefined) {
        _this.setState({
          docs: docs
        });
      }

      docs = _.sortBy(docs, function (doc) {
        return colDesc !== undefined && colDesc.computed ? colDesc.computed(doc) : doc[column];
      });

      if (order === 'desc') {
        docs = _.reverse(docs);
      }

      _this.setState({
        docs: docs
      });
    }, _this.handleSearch = function (text) {
      _this.setState({
        text: text
      }, _this.filterDocs);
    }, _temp));
  }

  _createClass(PaginatedStaticDataTable, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setState({
        page: 0,
        limit: 10,
        pagination: (this.props.docs || []).length > 10,
        docs: this.props.docs || [],
        sort: this.props.sort,
        text: this.props.text
      });
    }
  }, {
    key: "hasTextValue",
    value: function hasTextValue(doc, text) {
      if (text.length === 0) {
        return true;
      }

      for (var _i = 0, _Object$values = Object.values(doc); _i < _Object$values.length; _i++) {
        var value = _Object$values[_i];

        if (typeof value === 'string' && value.indexOf(text) >= 0) {
          return true;
        }

        if (typeof value === 'number' && value.toString().indexOf(text) >= 0) {
          return true;
        }
      }

      return false;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state2 = this.state,
          limit = _this$state2.limit,
          page = _this$state2.page,
          pagination = _this$state2.pagination,
          docs = _this$state2.docs;
      var _this$props2 = this.props,
          title = _this$props2.title,
          mapping = _this$props2.mapping,
          link = _this$props2.link,
          search = _this$props2.search,
          tableActions = _this$props2.tableActions,
          multiSelectId = _this$props2.multiSelectId,
          onSelectionChange = _this$props2.onSelectionChange,
          tableSelectionActions = _this$props2.tableSelectionActions,
          onRowClick = _this$props2.onRowClick,
          selectionByProps = _this$props2.selectionByProps;
      var total = docs.length;
      return React.createElement(React.Fragment, null, React.createElement(DataTable, {
        docs: docs.slice(page * limit, page * limit + limit),
        mapping: mapping,
        link: link,
        onSort: this.handleColumnSort,
        title: title,
        tableActions: tableActions,
        search: search,
        searchLive: search === 'live',
        searchFunction: this.handleSearch,
        multiSelectId: multiSelectId,
        onSelectionChange: onSelectionChange,
        onRowClick: onRowClick,
        tableSelectionActions: tableSelectionActions,
        selectedSimpleRow: selectionByProps
      }), total !== undefined && pagination && React.createElement(TablePagination, {
        component: 'div',
        count: total,
        rowsPerPage: limit,
        page: page,
        backIconButtonProps: {
          'aria-label': 'Previous Page'
        },
        nextIconButtonProps: {
          'aria-label': 'Next Page'
        },
        onChangePage: this.handleChangePage,
        onChangeRowsPerPage: this.handleChangeRowsPerPage
      }));
    }
  }]);

  return PaginatedStaticDataTable;
}(Component);

export default PaginatedStaticDataTable;